import { useMemo } from 'react'
import Group from 'components/utils/Group'
import WalledContent from 'components/Common/WalledContent'
import OfferTileLoggedInButtons from 'components/OfferList/OfferListTiles/Support/OfferTileLoggedInButtons'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import LEOfferForceBundlePricing from './LEOfferPricing/LEOfferForceBundlePricing'
import LEOfferPricing from './LEOfferPricing/LEOfferPricing'
import { unique } from 'lib/array/arrayUtils'
import { ViewOfferButton } from './ViewOfferButton'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCharterBundleRoute } from 'selectors/offerPage/initialOfferPageStateSelectors'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary | App.TourOffer | App.TourOfferSummary | App.VillaOffer | App.VillaOfferSummary
  variant?: 'default' | 'condensed'
  selectedDatesAndRoomsFilter?: App.OfferListFilters
}

function LEOfferPriceDetails(props: Props) {
  const {
    offer,
    variant = 'default',
    selectedDatesAndRoomsFilter,
  } = props

  const wall = <OfferTileLoggedInButtons
    signUpText="Sign up for free"
    align="right"
    fullWidth={false}
    discountLabelAlign="end"
  />
  const charterBundleRoute = useAppSelector(state => getCharterBundleRoute(state, offer))
  const shouldUseForceBundlePricing = !!(offer.bundledWithFlightsOnly || charterBundleRoute)
  const offerLocations = useMemo(() => unique(offer.locations.concat(offer.location)),
    [offer.locations, offer.location])
  const vendorName = offer.vendorName
  return (
    <WalledContent enforced={offer.walledGarden} wall={wall}>
      <Group direction="vertical" gap={8}>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
          <VerticalSpacer gap={8}>
            <div>
              {shouldUseForceBundlePricing && <LEOfferForceBundlePricing
                offer={offer}
                selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter}
              />}
              {!shouldUseForceBundlePricing && <LEOfferPricing
                offer={offer}
                selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter}
              />}
            </div>
            <PriceRowAgentHubCommission
              offerId={offer.id}
              offerLocations={offerLocations}
              vendorName={vendorName}
              productType={offer.productType}
            />
          </VerticalSpacer>
          <ProductPaletteProvider product={offer}>
            <ViewOfferButton variant={variant} />
          </ProductPaletteProvider>
        </Group>
      </Group>
    </WalledContent>
  )
}

export default LEOfferPriceDetails
